module.exports = __webpack_public_path__ + "static/media/info_24dp_FFFFFF.c6dabb3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info_24dp_FFFFFF.svg
// module id = 2442
// module chunks = 0